/* compoCASE – Korrekturen (ergänzend zu cc-custom.js) */
(function () {
  /* Startseite mobil: Video sofort starten (bei langsamer Verbindung kleinere 480p-Datei) */
  function heroVideoMobile() {
    var hero = document.querySelector('.jd-hero');
    if (!hero) return;
    var vids = [].slice.call(hero.querySelectorAll('video'));
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var c = navigator.connection || {};
    var slow = mobile && (c.saveData || /(^|-)2g|3g/.test(c.effectiveType || ''));
    vids.forEach(function (v, i) {
      v.muted = true; v.defaultMuted = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
      if (slow) {
        var src = v.querySelector('source');
        if (src && /HD-\d+p-[\d.]+Mbps/.test(src.src)) {
          src.src = src.src.replace(/HD-\d+p-[\d.]+Mbps/, 'SD-480p-1.5Mbps');
          if (i > 0) v.preload = 'metadata';
          v.load();
        }
      }
    });
    function start() {
      var active = hero.querySelector('.jd-hero__slide.is-active video') || vids[0];
      if (active && active.paused) { var p = active.play(); if (p && p.catch) p.catch(function () {}); }
    }
    start();
    vids.forEach(function (v) { v.addEventListener('canplay', start, { once: true }); });
    setTimeout(start, 400);
  }

  /* Produktseiten: Reiter (Technische Daten, Lieferumfang, Versand & Rückgabe) direkt vor die Beschreibung */
  function tabsBeforeDescription() {
    if (document.getElementById('ccx')) return;
    var tries = 0;
    (function move() {
      var tabs = document.getElementById('cc-tabs');
      var desc = document.querySelector('.product__info-container .product__description');
      if (!tabs || !desc) { if (tries++ < 40) setTimeout(move, 50); return; }
      var block = desc.closest('.product__info-container > *') || desc;
      if (tabs.nextElementSibling !== block) block.parentNode.insertBefore(tabs, block);
      tabs.classList.add('cc-tabs--top');
    })();
  }

  /* Mega-Menü am Desktop: Unterpunkte starten immer unter dem ersten Menüpunkt (Handyhüllen); Strich direkt unter dem aktiven Menüpunkt (CSS) */
  function alignMegaMenu() {
    var mq = window.matchMedia('(min-width: 990px)');
    function align(d) {
      if (!d || !d.closest || !d.closest('.header__inline-menu')) return;
      var list = d.querySelector('.mega-menu__list');
      var first = document.querySelector('.header__inline-menu .list-menu--inline > li');
      var label = first && (first.querySelector('summary span') || first.querySelector('a span') || first.querySelector('summary, a'));
      if (!list || !label) return;
      list.style.paddingLeft = '';
      if (!mq.matches || !d.hasAttribute('open')) return;
      var cs = getComputedStyle(list);
      var base = parseFloat(cs.paddingLeft) || 0;
      var padR = parseFloat(cs.paddingRight) || 0;
      var gap = parseFloat(cs.columnGap) || 0;
      var lis = [].slice.call(list.children);
      var total = lis.reduce(function (w, li) { return w + li.getBoundingClientRect().width; }, 0) + gap * Math.max(0, lis.length - 1);
      var lr = list.getBoundingClientRect();
      var want = label.getBoundingClientRect().left - lr.left;
      var room = lr.width - padR - total;
      list.style.setProperty('padding-left', Math.max(base, Math.min(want, room)) + 'px', 'important');
    }
    function later(d) { [0, 30, 120].forEach(function (t) { setTimeout(function () { align(d); }, t); }); }
    document.addEventListener('toggle', function (e) { if (e.target.tagName === 'DETAILS') later(e.target); }, true);
    document.addEventListener('mouseover', function (e) { var d = e.target.closest && e.target.closest('.header__inline-menu details'); if (d) later(d); }, true);
    document.addEventListener('click', function (e) { var d = e.target.closest && e.target.closest('.header__inline-menu details'); if (d) later(d); }, true);
    window.addEventListener('resize', function () { [].forEach.call(document.querySelectorAll('.header__inline-menu details[open]'), align); });
    window.ccAlignMegaMenu = align;
  }

  /* Für-Unternehmen-Seite: feste Sprungmarken für das Menü (#produkte, #staffelpreise, #ablauf, #anfrage) */
  function businessAnchors() {
    if (!/\/pages\/business/.test(location.pathname)) return;
    var map = { produkte: 'rich_text_GRzb4a', staffelpreise: 'custom_liquid_zJ8TLG', ablauf: 'custom_liquid_w9DaJp', anfrage: 'image_with_text_a3R7Ma', faq: 'collapsible_content_9AQ6TX' };
    function offset() {
      var h = document.querySelector('.section-header');
      return (h ? h.getBoundingClientRect().height : 80) + 16;
    }
    Object.keys(map).forEach(function (key) {
      if (document.getElementById(key)) return;
      var sec = document.querySelector('[id$="__' + map[key] + '"]');
      if (!sec) return;
      var a = document.createElement('div');
      a.id = key;
      a.setAttribute('aria-hidden', 'true');
      a.style.cssText = 'position:relative;height:0;overflow:hidden';
      sec.parentNode.insertBefore(a, sec);
    });
    function go(smooth) {
      var key = decodeURIComponent((location.hash || '').slice(1));
      var el = key && map[key] && document.getElementById(key);
      if (!el) return;
      el = el.nextElementSibling || el; /* leere Marker-Divs blendet das Theme aus, daher am Abschnitt messen */
      var y = el.getBoundingClientRect().top + window.pageYOffset - offset();
      window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' });
    }
    window.addEventListener('hashchange', function () { go(true); });
    document.addEventListener('click', function (e) {
      var l = e.target.closest && e.target.closest('a[href*="#"]');
      if (!l) return;
      var u = new URL(l.href, location.href);
      if (u.pathname === location.pathname && map[u.hash.slice(1)]) {
        e.preventDefault();
        var open = l.closest('details[open]');
        if (open) open.removeAttribute('open');
        history.pushState(null, '', u.hash);
        go(true);
      }
    }, true);
    if (location.hash) { go(false); setTimeout(function () { go(false); }, 400); window.addEventListener('load', function () { go(false); }); }
  }

  function run() { [heroVideoMobile, tabsBeforeDescription, alignMegaMenu, businessAnchors].forEach(function (f) { try { f(); } catch (e) { console.warn('cc-fixes', e); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
